import { render, staticRenderFns } from "./JustinMap.vue?vue&type=template&id=85fb582c&scoped=true&"
import script from "./JustinMap.vue?vue&type=script&lang=js&"
export * from "./JustinMap.vue?vue&type=script&lang=js&"
import style0 from "./JustinMap.vue?vue&type=style&index=0&id=85fb582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fb582c",
  null
  
)

export default component.exports